/**
 * EMAIL VALIDATION SCHEMA
 * * Infrastructure: Powered by Yup for robust object schema validation.
 * * Integration: Consumes centralized RegEx patterns and standardized 
 * error messages to ensure institutional consistency.
 */

import * as Yup from "yup";

/** * Pattern Dictionary:
 * Import centralized regular expression rules to maintain parity 
 * across the application's authentication modules.
 */
import { REGEX } from "../utils/regex";

/** * Message Dictionary:
 * Import localized error strings to ensure the UX provides clear, 
 * actionable feedback.
 */
import { ERROR_MESSAGES } from "./commonMessages";

// Email validation schema
export const emailValidation = Yup.string()
  /** * Presence Check:
   * Enforces that the field cannot be null or empty during form submission.
   */
  .required(ERROR_MESSAGES.EMAIL_REQUIRED)
  
  /** * Format Validation:
   * Compares input against the RFC-compliant EMAIL regular expression.
   * Ensures the presence of '@', a valid domain, and a supported TLD.
   */
  .matches(REGEX.EMAIL, ERROR_MESSAGES.EMAIL_INVALID);